<template>
  <BLayoutView
    :back-route="backRoute"
    :edit-route="editRoute"
    :title="pageTitle"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"

    :saveable="saveable"
    :editable="editable"
    :deletable="deletable"

    @save-menu="onSave"
    @delete="onDelete(single)"
  >
    <template #form>
      <ComponentForm
        ref="form"
        v-bind="viewTypeOptions"
        :data="viewTypeOptions.isCreate ? void 0 : single"
        :loading="isLoading"
        :editable="editable"
        :skeleton="isLoadingAsyncData"
        class="my-4"
      />
    </template>

    <template #footer.right>
      <v-btn
        v-if="!isLoadingAsyncData"
        outlined
        class="mr-2"
        :disabled="editable"
        @click="$refs.form.addSheet()"
        v-text="'Добавить лист'"
      />
      <v-btn
        v-if="!isLoadingAsyncData"
        :disabled="!hasEditableSheets || isOpenedModal"
        outlined
        @click="openModal"
        v-text="'Заполнить'"
      />
    </template>
  </BLayoutView>
</template>

<script>
import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { createDeletableMixin } from '@/helpers/mixins/createDeletableMixin'
import { PassportPageModel as Model } from './Model'
import { PassportTemplatesStoreModule as StoreModule } from './store'
import { PASSPORT_PAGES_ROUTES as ROUTES } from './utils'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import ComponentForm from './components/PassportTemplatesForm.vue'
import { createLKPublicationsFormdataModal } from '@/views/LKPublications/formdata/utils'


const mixinOptions = { Model, StoreModule, ROUTES }
const viewMixin = createViewMixin(mixinOptions)
const deletableMixin = createDeletableMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createViewMixin').ViewMixin<any, StoreModule> } View */
/** @typedef { import('@/helpers/mixins/createDeletableMixin').DeletableMixin<any, StoreModule> } Deletable */

export default {
  name: 'PassportTemplatesView',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BLayoutView,
    ComponentForm,
  },
  mixins: [
    viewMixin,
    deletableMixin,
  ],
  data: () => ({
    isOpenedModal: false,
    backRoute: { name: ROUTES.LIST },
  }),
  computed: {
    createRoute() {
      return {
        name: ROUTES.CREATE,
      }
    },
    editRoute() {
      return {
        name: ROUTES.EDIT,
        props: { id: this.id },
      }
    },
    hasEditableSheets() {
      return Boolean(
        this.$refs.form?.form?.sheets?.reduce(
          (isEditable, sheet) => isEditable || Boolean(sheet?.cells?.length),
          false,
        ),
      )
    },
  },
  /** @type { View & Deletable } */
  methods: {
    async onSave(type) {
      const form = await this.$refs.form.onSubmit()
      if (!form) {
        this.$notice.validatorFormError(this)
        return
      }
      const result = await this.onSubmit(form)
      this.$refs.form.onReset()

      const { id } = result
      const editRoute = { name: ROUTES.EDIT, params: { id } }
      this.toSave(this.backRoute, this.createRoute, editRoute, type)
    },
    async onDelete(data) {
      const result = await this.toDelete(data)
      if (!result) return
      this.$router.replace(this.backRoute)
    },
    async openModal() {
      if (!this.hasEditableSheets) return
      this.isOpenedModal = true
      const form = JSON.parse(JSON.stringify(this.$refs.form.form))
      // eslint-disable-next-line object-curly-newline
      const options = { formTemplate: form, resetOnClose: true, excel: true, canEdit: true }
      const modal = await createLKPublicationsFormdataModal(this, options)
      await modal.open()
      this.isOpenedModal = false
    },
  },
}
</script>
